import { useEffect, useState } from 'react';
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Input,
  Segment,
  Tab,
} from 'semantic-ui-react';
import '../communication.css';
import { useStore } from '../../../app/stores/store';
import APICardBox from './APICardBox';
import { observer } from 'mobx-react-lite';
import { ApiSetting } from '../../../app/common/options/dashboardOptions/milestoneOptions';

function APISetting() {
  const [selected, setSelected] = useState<string[]>([]);

  const { TemplateStore, ApiStore, ElementStore } = useStore();
  const { apiInput, getAnyApiMethod, statusActiveindexes, statusActiveIndex } =
    ApiStore;

  const {
    selectedAssetType,
    selectedElementTypes,
    selectedTemplate,
    selectedTasks,
    selectedSubTasks,
  } = TemplateStore;
  const [selectedAssetName] = useState(selectedAssetType);
  const [paneStore, setPaneStore] = useState<any[]>([]);
  const [getSelectOption, setGetSelectOption] = useState([]);
  const [blockGetUseEffect, setBlockGetUseEffect] = useState<boolean>(true);
  const [mappingData, setMappingData] = useState([]);
  const [externalApi, setExternalApi] = useState(false);
  const [apisave, setApisave] = useState(false);
  const [externalApiMsg, setExternalApiMsg] = useState(false);
  const [, setTokenChecker] = useState(false);
  const [tokenvalue, setTokenvalue] = useState('');
  const [, setEmttokenchecker] = useState(false);
  // const [activeIndex, setActiveIndex] = useState<number>(0);
  // // const [number,setNumber] = useState(0)

  const handleTabChange: any = (
    e: any,
    { activeIndex }: { activeIndex: number },
  ) => {
    // setActiveIndex(activeIndex);
    statusActiveindexes(activeIndex);
    updateApiScheme();
  };

  useEffect(() => {
    if (selectedAssetName?.typeName === undefined) {
      window.history.back();
    }
    // eslint-disable-next-line
  }, []);

  const pane: any =
    paneStore !== undefined
      ? paneStore?.map((data: string, i: number) => ({
          menuItem: selected[i],
          render: () => getPanes(data, i),
        }))
      : null;

  const handleTabDelete = (e: any, name: string) => {
    // delete tab logic
    let copySelected = Object.assign([], selected);
    let findIndex = copySelected.findIndex((d) => d === name);
    copySelected.splice(findIndex, 1);

    if (statusActiveIndex === findIndex) {
      statusActiveindexes(findIndex - 1 === -1 ? 0 : findIndex - 1);
    }
    setSelected(copySelected);
  };
  //defined once can use it anywhere
  const getPanes = (data: string, i: number) => {
    return (
      <APICardBox
        key={'key-' + i}
        selectedElementDat={selectedSubTasks?.elements}
        commScheme={data}
        setMappingData={setMappingData}
        externalApi={externalApi}
        externalApiMsg={externalApiMsg}
        setTokenChecker={setTokenChecker}
        setTokenvalue={setTokenvalue}
        tokenvalue={tokenvalue}
        setEmttokenchecker={setEmttokenchecker}
        setApisave={setApisave}
      />
    );
  };
  useEffect(() => {
    if (selectedSubTasks?.subTaskId !== undefined) {
      ApiStore.DynamicAssetId(selectedSubTasks?.subTaskId);
    }
    // eslint-disable-next-line
  }, [selectedSubTasks]);

  useEffect(() => {
    if (externalApi === true) {
      if (apiInput.isExternalAPI.includes('Bearer') !== false) {
        setTokenChecker(true);
      } else {
        setTokenChecker(false);
      }
    }
  }, [apiInput.isExternalAPI, externalApi, ApiStore.subtaskToken]);

  useEffect(() => {
    // Get Saved Api data
    if (blockGetUseEffect) {
      const apiData: any = selectedSubTasks?.api;
      apiData?.sort((a: any, b: any) =>
        a.status < b.status ? -1 : a.status > b.status ? 1 : 0,
      );
      if (apiData !== undefined && apiData !== null && apiData.length !== 0) {
        let actionStatus = '';
        const setArrSelected: any = [];
        apiData.forEach((data: any) => {
          switch (data.status) {
            case 1:
              actionStatus = 'Start';
              break;
            case 2:
              actionStatus = 'Complete';
              break;
            case 3:
              actionStatus = 'Hold';
              break;
            case 4:
              actionStatus = 'Resume';
              break;
            case 5:
              actionStatus = 'Reject';
              break;
            case 6:
              actionStatus = 'Rework';
              break;
            case 7:
              actionStatus = 'Resolve';
              break;
            case 8:
              actionStatus = 'V1';
              break;
            case 9:
              actionStatus = 'V2';
              break;
            case 10:
              actionStatus = 'V3';
              break;
          }
          setArrSelected.push(actionStatus);
        });
        setArrSelected?.filter(
          (a: any, b: any) => setArrSelected?.indexOf(a) === b,
        );
        // const removeDuplicates = (arr) => [...new Set(arr)];
        var unique = setArrSelected.filter(
          (v: any, i: any, a: any) => a.indexOf(v) === i,
        );
        if (getSelectOption.length === 0) unique.length = 0;
        setSelected(unique);
        apiInput.getApiInitScheme = apiData;
        setPaneStore(apiInput.getApiInitScheme);
      }
    }
    // eslint-disable-next-line
  }, [paneStore, selectedSubTasks, apiInput]);

  useEffect(() => {
    setPaneStore(apiInput.getApiInitScheme);
  }, [selected, ApiStore, apiInput]);

  useEffect(() => {
    const apiData: any = selectedSubTasks?.api;
    apiData?.sort((a: any, b: any) =>
      a.status < b.status ? -1 : a.status > b.status ? 1 : 0,
    );
    if (apiData !== undefined && apiData !== null && apiData.length !== 0) {
      let actionStatus = '';
      const setArrSelectedLower: any = [];
      apiData.forEach((data: any) => {
        switch (data.status) {
          case 1:
            actionStatus = 'Start';
            break;
          case 2:
            actionStatus = 'Complete';
            break;
          case 3:
            actionStatus = 'Hold';
            break;
          case 4:
            actionStatus = 'Resume';
            break;
          case 5:
            actionStatus = 'Reject';
            break;
          case 6:
            actionStatus = 'Rework';
            break;
          case 7:
            actionStatus = 'Resolve';
            break;
          case 8:
            actionStatus = 'V1';
            break;
          case 9:
            actionStatus = 'V2';
            break;
          case 10:
            actionStatus = 'V3';
            break;
        }
        setArrSelectedLower.push(actionStatus.toLowerCase());
      });
      let unique = setArrSelectedLower?.filter(
        (v: any, i: any, a: any) => a.indexOf(v) === i,
      );
      setGetSelectOption(unique);
    }
  }, [selectedSubTasks?.api]);

  // main handle add row for adding pane
  const handleAddRow = (e: any, data: any) => {
    e.preventDefault();
    setBlockGetUseEffect(false);
    setGetSelectOption(data.value);
    if (
      e.currentTarget.parentElement.className === 'ui label' ||
      e.currentTarget.parentElement.className === 'ui active label'
    ) {
      // Delete api
      let actionStatus = 0;
      switch (e.currentTarget.parentElement.textContent) {
        case 'Start':
          actionStatus = 1;
          break;
        case 'Complete':
          actionStatus = 2;
          break;
        case 'Hold':
          actionStatus = 3;
          break;
        case 'Resume':
          actionStatus = 4;
          break;
        case 'Reject':
          actionStatus = 5;
          break;
        case 'Rework':
          actionStatus = 6;
          break;
        case 'Resolve':
          actionStatus = 7;
          break;
        case 'V1':
          actionStatus = 8;
          break;
        case 'V2':
          actionStatus = 9;
          break;
        case 'V3':
          actionStatus = 10;
          break;
      }
      const apiDeleteData = apiInput.getApiInitScheme?.filter(
        (item: any) => item.status === actionStatus,
      );
      const filteredDelData = apiInput.getApiInitScheme?.filter(
        (item: any) => item.status !== actionStatus,
      );
      handleTabDelete(
        filteredDelData,
        e.currentTarget.parentElement.textContent,
      );
      const p1 = new Promise((resolve) => {
        ApiStore.deleteApi(apiDeleteData[0]?.id, filteredDelData);
        resolve('');
      });
      p1.then(() => {
        if (selectedSubTasks?.subTaskId) return;
        TemplateStore.loadSubTaskById(selectedSubTasks?.subTaskId);
      });
    } else {
      setSelected([...selected, e.currentTarget.textContent]);
      ApiStore.setApiScheme(e.currentTarget.textContent);

      const apiPostStructure = {
        subTaskId: selectedSubTasks?.subTaskId,
        api: apiInput.addNewApiTab,
      };
      ApiStore.postApi(apiPostStructure);
      setPaneStore(apiInput.getApiInitScheme);
    }
  };

  //final Save
  const saveStatusMsg = () => {
    updateApiScheme();
    apiInput.getApiInitScheme[0].data = JSON.stringify(mappingData);
    const apiPostStructure = {
      subTaskId: selectedSubTasks?.subTaskId,
      api: apiInput.getApiInitScheme,
    };
    ApiStore.putApi(apiPostStructure);
    setExternalApiMsg(true);
  };
  //final Test
  const saveStatusMsg2 = () => {
    updateApiScheme();
    let APIData = apiInput.getApiInitScheme;
    let cleanText = APIData[0].url.replace(/<\/?[^>]+(>|$)/g, '');
    getAnyApiMethod(cleanText);

    // const apiPostStructure = {
    //   subTaskId: selectedSubTasks?.subTaskId,
    //   api: apiInput.getApiInitScheme
    // }
    // ApiStore.putApi(apiPostStructure);
  };
  //on tab change or final Save
  const updateApiScheme = () => {
    apiInput.getApiInitScheme.forEach((data: any) => {
      if (apiInput.apiBody !== '') {
        const msgUpdateVal = apiInput.apiBody.split('|');
        if (data.status === parseInt(msgUpdateVal[1])) {
          data.body = msgUpdateVal[0];
          const modelData: string = '<br>';
          const modelData1: string = '<br>|1';
          if (
            data.body === modelData ||
            data.body === modelData1 ||
            data.body === '&nbsp;|1' ||
            data.body === '&nbsp;'
          ) {
            data.model = '{}';
          }
        }
      }
      if (apiInput.apiUrlInput !== '') {
        const urlUpdateVal = apiInput.apiUrlInput.split('|');
        if (data.status === parseInt(urlUpdateVal[1])) {
          data.url = urlUpdateVal[0];
        }
      }
      if (apiInput.isExternalAPI !== '') {
        const urlUpdateVal = apiInput.isExternalAPI.split('|');
        if (data.isExternalAPI === true) {
          data.isExternalAPI = urlUpdateVal[1];
          data.token = urlUpdateVal[0];
        }
      }
    });
    setPaneStore(apiInput.getApiInitScheme);
    // setActiveIndex(activeIndex)
  };
  useEffect(() => {
    window.addEventListener('popstate', () => {
      // window.location.reload();
      TemplateStore.loadAssetTypes();
      // store.TemplateStore.selectedSubTasks=undefined;
    });
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (selectedAssetName?.typeName === undefined) {
      window.history.back();
    }
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {}, [externalApi]);

  // eslint-disable-next-line
  const checkboxUrlfield = (e: any, data: any) => {
    setExternalApi(data.checked);
    setApisave(true);
  };

  return (
    <>
      <Header
        style={{ marginTop: '10px', marginLeft: '20px' }}
        icon="rocketchat"
        size="huge"
        dividing
        as="h1"
        content="API Setting"
        sub
        color="grey"
      />
      <Segment basic className="api-container scroll">
        <Grid columns={6}>
          <Grid.Row>
            <Grid.Column>
              <Input disabled value={selectedAssetName?.typeName} />
            </Grid.Column>
            <Grid.Column>
              <Input disabled value={selectedElementTypes?.elementName} />
            </Grid.Column>
            <Grid.Column>
              <Input disabled value={selectedTemplate?.templateName} />
            </Grid.Column>
            <Grid.Column>
              <Input disabled value={selectedTasks?.taskName} />
            </Grid.Column>
            <Grid.Column>
              <Input disabled value={selectedSubTasks?.subTaskName} />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                style={{ width: '100%' }}
                placeholder="--Select--"
                search
                selection
                options={ApiSetting}
                onChange={(e, data) => handleAddRow(e, data)}
                value={getSelectOption}
                clearable
                fluid
                multiple
                className="clear-selection"
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className="api-settings-cta">
            {selected.length > 0 && (
              <>
                <div>
                  {/* <Checkbox
                  label="External API"
                  onClick={(e, data) => checkboxUrlfield(e, data)}
                /> */}
                  {ElementStore.setGetMethodClicked && (
                    <Button secondary onClick={saveStatusMsg2}>
                      Test
                    </Button>
                  )}
                  <Button
                    positive
                    onClick={saveStatusMsg}
                    // disabled={!(tokenchecker && emttokenchecker)}
                    disabled={apisave}
                  >
                    Save
                  </Button>
                </div>
              </>
            )}
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              {selected.length > 0 && (
                <Tab
                  activeIndex={statusActiveIndex}
                  onTabChange={handleTabChange}
                  panes={pane}
                />
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </>
  );
}

export default observer(APISetting);
